import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MagnifyingGlassIcon, PlusCircleIcon } from '@heroicons/react/24/outline';

const MobileHeader: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
      setSearchQuery('');
    }
  };

  return (
    <div
      className="position-sticky top-0 z-50"
      style={{
        background: 'rgba(255, 249, 244, 0.95)',
        backdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: '1px solid rgba(244, 223, 204, 0.6)',
      }}
    >
      <div className="d-flex align-items-center gap-2 px-3 py-2">
        {/* Logo */}
        <img
          src="/logo.png"
          alt="NayaBajar"
          onClick={() => navigate('/')}
          style={{ height: 30, width: 'auto', flexShrink: 0, cursor: 'pointer' }}
        />

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="flex-grow-1 position-relative">
          <input
            type="text"
            placeholder="Search for anything"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: '100%',
              background: 'var(--pw-surface-tint)',
              border: '1.5px solid var(--pw-border)',
              borderRadius: 14,
              padding: '10px 14px 10px 38px',
              fontSize: 14,
              color: 'var(--pw-text)',
              outline: 'none',
              transition: 'all 0.2s ease',
            }}
            onFocus={(e) => {
              e.currentTarget.style.background = 'var(--pw-surface)';
              e.currentTarget.style.borderColor = 'var(--pw-primary-light)';
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(232, 93, 76, 0.1)';
            }}
            onBlur={(e) => {
              e.currentTarget.style.background = 'var(--pw-surface-tint)';
              e.currentTarget.style.borderColor = 'var(--pw-border)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          />
          <MagnifyingGlassIcon
            style={{
              width: 18,
              height: 18,
              color: 'var(--pw-text-muted)',
              position: 'absolute',
              left: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
            }}
          />
        </form>

        {/* Post Ad Button */}
        <button
          onClick={() => navigate('/post-ad')}
          className="d-flex align-items-center justify-content-center border-0"
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            background: 'linear-gradient(135deg, var(--pw-accent) 0%, #f5a623 100%)',
            color: '#5c3d0d',
            flexShrink: 0,
            boxShadow: '0 4px 12px rgba(255, 191, 77, 0.25)',
            transition: 'transform 0.15s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <PlusCircleIcon style={{ width: 22, height: 22 }} />
        </button>
      </div>
    </div>
  );
};

export default MobileHeader;
